export default "__VITE_ASSET__Clwpu9N2__"